import styled from 'styled-components';
export const StyledTagContainer = styled.div`
  position: absolute;
  z-index: 20 !important;

  display: flex;
  flex-grow: 0;
  flex-direction: column;
  gap: 1.2rem;

  bottom: 3rem;
  left: 1.8rem;

  @media screen and (min-width: 576px) {
    bottom: 4.6rem;
    left: 30rem;
  }

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) {
    left: 35.2rem;
  }

  & > * {
    background-color: ${({
  theme
}) => theme.colors.warning.lighter};
    font-family: ${({
  theme
}) => theme.fonts.familySansPro};
    font-size: ${({
  theme
}) => theme.fonts.sizes.default};
    width: fit-content;
  }
`;